export default __webpack_public_path__ + "static/media/21.94fba182.jpg";